import { render, staticRenderFns } from "./reviewPaper.vue?vue&type=template&id=0a066761&scoped=true"
import script from "./reviewPaper.vue?vue&type=script&lang=js"
export * from "./reviewPaper.vue?vue&type=script&lang=js"
import style0 from "./reviewPaper.vue?vue&type=style&index=0&id=0a066761&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a066761",
  null
  
)

export default component.exports